interface IconWithTextProps {
    icon: string;
    text: string;
}

const IconWithText = ({ icon, text }: IconWithTextProps) => (
    <div className="flex items-start gap-4">
        <img src={icon} alt={text} className="image-icon" />
        <span className="text-white text-xs md:text-base ">{text}</span>
    </div>
);

export default IconWithText;
